import { Link } from 'react-router-dom';
import LineCtaButton from '@/pages/gmb-audit/consult/components/LineCtaButton';
import type { ConsultReportContext } from '@/pages/gmb-audit/consult/utils/consultContext';

/**
 * 報告底部 CTA #3（strong）— V1 Conversion-1。
 * 視覺層級：CTA #1 light → CTA #2 medium → CTA #3 strong。
 * Primary 導向 /gmb-audit/consult（以 navigation state 帶入 context）；Secondary 為 LINE。
 * 低壓文案、無倒數 / 限時 / 恐嚇式促銷。
 */
export default function ReportCtaSection({
  onRestart,
  context,
}: {
  onRestart: () => void;
  context: ConsultReportContext | null;
}) {
  return (
    <section className="ds-container pt-16 md:pt-20">
      <div className="overflow-hidden rounded-2xl border border-primary-300 bg-primary-700 p-6 shadow-card md:p-10">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-wide text-primary-200">下一步</p>
          <h2 className="mt-2 text-2xl font-bold leading-snug text-background-50 md:text-[2rem]">
            看完健診，還是不知道該先改哪一項？
          </h2>
          <p className="mt-4 text-base leading-relaxed text-primary-100 md:text-lg">
            每一家店的問題不同，不一定分數最低的項目就要第一個處理。讓天地人網依你的健診結果、產業與目前經營狀況，一起排出真正適合的改善順序。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:gap-4">
            <Link
              to="/gmb-audit/consult"
              state={{ consultContext: context }}
              className="inline-flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-background-50 px-7 text-base font-semibold text-primary-800 transition-colors hover:bg-background-100 sm:w-auto"
            >
              <i className="ri-customer-service-2-line text-lg" />
              預約健診諮詢
            </Link>
            <LineCtaButton variant="inverse" fullWidth className="sm:w-auto" />
          </div>

          <p className="mt-4 text-sm text-primary-100/90">
            先了解方向，不代表一定要購買服務。
          </p>
        </div>

        <div className="mt-8 border-t border-primary-600/60 pt-5">
          <button
            type="button"
            onClick={onRestart}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg px-1 py-1 text-base font-semibold text-primary-100 transition-colors hover:text-background-50"
          >
            <i className="ri-refresh-line text-lg" />
            重新健診其他商家
          </button>
        </div>
      </div>
    </section>
  );
}